










































































































































































































































































































































































































import { Component } from 'vue-property-decorator';
import BaseComponent from '../../../core/base.component';
import { CompanyListDto, CompanyDto, CompanyAddrssDataDto } from '../../../dto';
import { Pagination } from '../../../common';
import CompanyService from '../../../services/company.service';
import {
  CONST_APPROVAL_STATUS,
  APPROVAL_STATUS,
} from '../../../services/shared';
import { FileAttachmentDto } from '@/services/shared/file-upload';
import FileUploadService from '../../../services/shared/file-upload/file-upload.service';
import { UPLOAD_TYPE } from '../../../services/shared/file-upload/file-upload.service';
import { ATTACHMENT_REASON_TYPE } from '@/services/shared/file-upload';
import { getStatusColor } from '../../../core/utils/status-color.util';
import { ClearOutQueryParamMapper, ReverseQueryParamMapper } from '@/core';
import toast from '../../../../resources/assets/js/services/toast.js';

@Component({
  name: 'CompanyList',
})
export default class CompanyList extends BaseComponent {
  constructor() {
    super();
  }
  private companySearchDto = new CompanyListDto();
  //   or you can set this value to an empty erray. either or
  //   private companyList: Array<CompanyDto>();
  private companyList: CompanyDto[] = [];
  private companyTotalCount = null;
  private companyCreateDto = new CompanyDto();
  private companySelect: CompanyDto[] = [];
  private pagination = new Pagination();
  private approvalStatus: APPROVAL_STATUS[] = [...CONST_APPROVAL_STATUS];
  private totalPage = 0;
  private dataLoading = false;
  // single file일 경우 치환자를 attachment으로 정한다
  private companyLogo: FileAttachmentDto[] = [];
  private addressData = new CompanyAddrssDataDto();
  private searchQueryParamsDto: any = {};

  // get status color
  getStatusColor(status: APPROVAL_STATUS) {
    return getStatusColor(status);
  }

  // 업체 셀렉트 박스
  getCompanies() {
    CompanyService.findAllForSelect().subscribe(res => {
      this.companySelect = res.data;
    });
  }

  // 주소 검색 모달
  showAddressModal() {
    this.$bvModal.show('postcode');
  }

  findAll(isPagination?: boolean, isSearch?: boolean) {
    this.dataLoading = true;
    if (!isPagination) {
      this.pagination.page = 1;
    } else {
      if (isSearch) this.pagination.page = 1;
      this.searchQueryParamsDto = Object.assign(
        this.companySearchDto,
        this.pagination,
      );
    }

    CompanyService.findAll(this.companySearchDto, this.pagination).subscribe(
      res => {
        this.dataLoading = false;
        this.companyList = res.data.items;
        this.companyTotalCount = res.data.totalCount;
        this.totalPage = Math.ceil(
          this.companyTotalCount / this.pagination.limit,
        );
        this.$router
          .push({
            query: this.searchQueryParamsDto,
          })
          .catch(() => {
            //
          });
      },
    );
  }

  paginateSearch() {
    this.findAll(true);
  }

  search() {
    this.findAll(true, true);
  }

  clearOut() {
    if (location.search) {
      ClearOutQueryParamMapper();
    } else {
      this.companySearchDto = new CompanyListDto();
      this.findAll();
    }
  }

  async upload(file: File) {
    const attachments = await FileUploadService.upload(
      UPLOAD_TYPE.COMPANY_LOGO,
      [file],
    );
    this.companyLogo = [];
    this.companyLogo.push(
      ...attachments.filter(
        fileUpload =>
          fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
      ),
    );
  }

  // create company
  createCompany() {
    if (this.companyLogo.length > 0) {
      this.companyCreateDto.logo = this.companyLogo;
    }

    this.companyCreateDto.address = `${
      this.addressData.address ? this.addressData.address : ''
    } ${this.addressData.addressDetail ? this.addressData.addressDetail : ''}`;

    // default status
    this.companyCreateDto.companyStatus = APPROVAL_STATUS.APPROVAL;
    CompanyService.createCompany(this.companyCreateDto).subscribe(res => {
      if (res) {
        toast.success('추가완료');
        this.clearOut();
        this.$bvModal.hide('add_company');
      }
    });
  }

  setAddress(res) {
    this.addressData = res;
    this.companyCreateDto.address = this.addressData.address;
    this.$bvModal.hide('postcode');
  }

  // 업체 생성 초기화
  clearOutCompanyCreateDto() {
    this.companyCreateDto = new CompanyDto();
    this.addressData = new CompanyAddrssDataDto();
    this.companyLogo = [];
  }

  created() {
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.companySearchDto = query;
      if (!isNaN(+query.limit) && !isNaN(+query.page)) {
        this.pagination.limit = +query.limit;
        this.pagination.page = +query.page;
      } else {
        this.pagination = new Pagination();
      }
      this.paginateSearch();
    } else {
      this.findAll();
    }
    this.getCompanies();
  }
}
